import { render, staticRenderFns } from "./linked-risk-collapsible.vue?vue&type=template&id=76fb2d7e"
import script from "./linked-risk-collapsible.ts?vue&type=script&lang=ts&external"
export * from "./linked-risk-collapsible.ts?vue&type=script&lang=ts&external"
import style0 from "./linked-risk-collapsible.scss?vue&type=style&index=0&lang=scss&external"


/* normalize component */
import normalizer from "!../../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/src/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('76fb2d7e')) {
      api.createRecord('76fb2d7e', component.options)
    } else {
      api.reload('76fb2d7e', component.options)
    }
    module.hot.accept("./linked-risk-collapsible.vue?vue&type=template&id=76fb2d7e", function () {
      api.rerender('76fb2d7e', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/components/in-year-budget-requests/linked-external-ids-collapsible/linked-risk-collapsible/linked-risk-collapsible.vue"
export default component.exports